import { createSelector, DefaultProjectorFn, MemoizedSelector } from '@ngrx/store';

import { AppState } from '../../app.state';

import { SUPPORTED_LANGUAGE } from './language.model';
import { LanguageState } from './language.state';

export namespace LanguageSelectors {
  export const languageState = (state: AppState): LanguageState => state.language;

  export function selectState(): MemoizedSelector<
    AppState,
    LanguageState,
    DefaultProjectorFn<LanguageState>
  > {
    return createSelector(languageState, (state: LanguageState) => state);
  }

  export function selectLanguageCode(): MemoizedSelector<
    AppState,
    SUPPORTED_LANGUAGE,
    DefaultProjectorFn<SUPPORTED_LANGUAGE>
  > {
    return createSelector(languageState, (state: LanguageState) => state.languageCode);
  }

  export const selectIsLoaded = createSelector(
    languageState,
    (state: LanguageState): boolean => state.loaded
  );
}
